import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import DotSpinner from '../../components/shared/DotSpinner';
import chatService from '../../services/chat.service';
import { apiEvents } from '../../api/apiEvents.api';
import config from '../../config';

// «Выслать приглашение»: список чатов, клик по человеку — приглашение уходит в чат
function EventInvite() {
  const { id } = useParams();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sendingChatId, setSendingChatId] = useState(null);

  useEffect(() => {
    let cancelled = false;

    chatService
      .getUserChats(axiosPrivate, 1, 50)
      .then((res) => {
        if (cancelled) return;
        const list = res?.data?.chats || [];
        setChats(Array.isArray(list) ? list : list?.items || []);
      })
      .catch(() => {
        if (!cancelled) setChats([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [axiosPrivate]);

  const handleInvite = async (chat) => {
    if (sendingChatId) return;
    setSendingChatId(chat._id);

    try {
      await apiEvents.invite(axiosPrivate, id, chat._id);
      toast.success('Приглашение отправлено');
      navigate(config.ROUTES.CHATS.TEXT(chat._id));
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Не удалось отправить приглашение');
      setSendingChatId(null);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-y-auto">
      {chats.length === 0 ? (
        <div className="flex flex-col items-center justify-center min-h-[50vh] px-4">
          <p className="text-white/60 text-center text-[15px] font-raleway">
            У вас пока нет чатов. Найдите собеседника на вкладке «Знакомства» — и приглашайте его на
            мероприятия!
          </p>
        </div>
      ) : (
        <div className="flex flex-col">
          {chats.map((chat) => {
            const last = chat.lastMessage;
            const lastLabel = chat.blockedMe
              ? 'Вы заблокированы пользователем'
              : last?.type === 'event'
                ? 'Приглашение на мероприятие'
                : last?.type === 'gift'
                  ? 'Подарок'
                  : last?.text || 'Нет сообщений';
            const time = last?.createdAt
              ? new Date(last.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
              : '';

            return (
              <button
                key={chat._id}
                onClick={() => handleInvite(chat)}
                disabled={Boolean(sendingChatId)}
                className="flex items-center gap-3 px-4 py-3 border-b border-[#233636] w-full text-left active:bg-[#043939] disabled:opacity-60"
              >
                <img
                  src={chat.partner?.photo || '/mock/stream_chat_user_avatar.png'}
                  alt={chat.partner?.name || ''}
                  className="w-[48px] h-[48px] rounded-full object-cover shrink-0"
                />
                <div className="flex flex-col min-w-0 flex-1 gap-0.5">
                  <p className="text-white text-[16px] font-semibold font-raleway truncate">
                    {chat.partner?.name || 'Пользователь'}
                  </p>
                  <p className="text-white/60 text-[13px] font-raleway truncate">{lastLabel}</p>
                </div>
                <div className="flex flex-col items-end shrink-0 gap-0.5">
                  <span className="text-white/70 text-[13px] font-raleway">{time}</span>
                  {sendingChatId === chat._id && (
                    <span className="text-[#A1F69E] text-[12px] font-raleway">Отправляем…</span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default EventInvite;
